import React, { useState, useEffect } from 'react';
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import cancelCsv from './../../../../../../Assets/icons/cancelCsv.svg';
// import "./index.scss";
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../../customformComponent/customForm/DynamicForm';
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../../../../../services/api/API';
import { showCustomAlert } from '../../../../../customComponents/CustomSweetAlert';
import { showErrorAlert } from '../../../../../customComponents/CustomSweetAlert/errorsweetalert';
import Loader from '../../../../../customComponents/CustomLoader';
import { showAlert } from '../../../../../customComponents/CustomSweetAlert/ShowAlert';
import Swal from 'sweetalert2';
import validations from '../../../../../../helpers/validations';
import { buttonStyle, isFormValid } from '../../../../../../helpers/common';

const AddStockIn = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');

  const userType = localStorage.getItem('UserType');
  const businessPartnerId = localStorage.getItem('businessPartnerId');

  const handleModalClose = () => {
    setShowModal(false);
    setFormData({});
  };

  const handleModalOpen = () => {
    setShowModal(true);
  };

  useEffect(() => {
    fetchVariantOptions();
  }, []);

  const fetchVariantOptions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {
          batteryType: 'N',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    fetchItemOptions();
  }, []);

  const fetchItemOptions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitem',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log('productformdata', formData);

    // Validate form before submission
    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await showAlert({
      title: 'Confirmation',
      text: 'Are you sure you want to add this item to stock?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      // const payload = {
      //   quantity: formData.quantity,
      //   item_id:
      //     formData.itemType === "V" ? formData.variant : formData.accessory,
      // };

      const typeMap = {
        V: 3, // Vehicle
        S: 1, // Spare Part
        A: 2, // Accessories
      };

      const payload = {
        quantity: formData.quantity,
        // itemtype_id: formData.itemType,
        itemtype_id: typeMap[formData.itemType] ?? null,
        ...(formData.itemType === 'V'
          ? { variant_id: formData.variant }
          : { item_id: formData.accessory }),
      };

      const response = await axiosInstance.post('/inStock/add-stock', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log('API Response:', response.data);

      if (response.status === 200) {
        await showAlert({
          title: 'Success',
          text: 'Item added to stock successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        navigate('/admin/manage-product/stock-in');
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      const errorMessage =
        error.response?.data?.message ||
        'An error occurred while processing your request.';
      await showAlert({
        title: 'Something went wrong',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
      setLoading(false);
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  // const handleDownload = async (formData) => {
  //   console.log("productformdata", formData);

  //   // Validate form before submission
  //   const errors = {};
  //   let isValid = true;

  //   BulkUploadInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.required &&
  //         field.validation &&
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   const confirmation = await showAlert({
  //     title: "Confirmation",
  //     text: "Are you sure you want to download?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (!confirmation.isConfirmed) {
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const payload = {
  //       variantIds: formData.variantIds || [],
  //       itemIds: formData.itemIds || [],
  //     };

  //     const response = await axiosInstance.post(
  //       "/instock/download-excell-sample",
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     console.log("API Response:", response.data);

  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Item added to stock successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //       // navigate("/admin/manage-product/stock-in");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);

  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "An error occurred while processing your request.";
  //     await showAlert({
  //       title: "Something went wrong",
  //       text: errorMessage,
  //       confirmButtonText: "OK",
  //     });
  //     setLoading(false);
  //   } finally {
  //     setLoading(false); // Hide loading state
  //   }
  // };

  useEffect(() => {
    console.log('formData changed:', formData);
  });

  const handleDownload = async (formData) => {
    if (!formData.itemTypebulk) {
      setErrorMessage('Select item type first');

      Swal.fire({
        title: 'Cancelled',
        text: 'Select item type first.',
        icon: 'info',
        confirmButtonText: 'OK',
      });

      return;
    }

    setErrorMessage('');

    try {
      const payload = {
        variantIds: formData.variantIds || [],
        itemIds: formData.itemIds || [],
      };

      const response = await axiosInstance.post(
        `/instock/download-excell-sample`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          responseType: 'blob', // Set response type to blob for file downloads
        },
      );

      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement('a');
      link.href = url;

      // Set the file name for the download to .csv
      link.setAttribute('download', 'sample.csv'); // Changed to .csv

      // Append the link to the body (required for some browsers)
      document.body.appendChild(link);

      // Programmatically trigger the click event on the link
      link.click();

      // Clean up the link after download
      document.body.removeChild(link);

      if (response.status === 200) {
        setFormData({
          itemTypebulk: '',
          variantIds: '',
          itemIds: '',
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const CustomerInputs = [
    {
      name: 'itemType',
      label: 'Item Type',
      placeholder: 'Enter',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    ...(formData.itemType === 'V'
      ? [
          {
            // name: "variant",
            name: 'variant',
            label: 'Variant',
            placeholder: '',
            type: 'dropdown',
            options: variantOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemType !== 'V'
      ? [
          {
            name: 'accessory',
            label: 'Item Name',
            placeholder: '',
            type: 'dropdown',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    {
      name: 'quantity',
      label: 'Quantity',
      placeholder: 'Enter Quantity',
      type: 'number',
      required: true,
      gridClass: 'col-lg-3',
      validation: validations.quantity({
        required: true,
        minLength: 1,
        maxLength: 3,
        pattern: /^[1-9][0-9]*$/,
      }),
      // validation: {
      //   required: true,
      //   pattern: /^[1-9][0-9]*$/,
      //   message: "Please enter a positive number with no leading zeros",
      // },
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "toggle",
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "productimage",
    //   label: "Upload Product Brochure",
    //   type: "productfile",
    //   required: true,
    //   gridClass: "col-lg-6",
    //   validation: { required: true },
    // },
  ];

  const BulkUploadInputs = [
    {
      name: 'itemTypebulk',
      label: 'Item Type',
      placeholder: 'Enter',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    ...(formData.itemTypebulk === 'V'
      ? [
          {
            // name: "variant",
            name: 'variantIds',
            label: 'Variant',
            placeholder: '',
            type: 'multiselectdropdownStockin',
            options: variantOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemTypebulk !== 'V'
      ? [
          {
            name: 'itemIds',
            label: 'Item Name',
            placeholder: '',
            type: 'multiselectdropdownStockin',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
  ];

  const UploadInputs = [
    {
      name: 'bulksrnoUpload',
      label: 'Upload Updated Quantity',
      type: 'file',
      required: true,
      gridClass: 'col-lg-12',
      validation: {
        required: true,
        allowedExtensions: ['csv'], // Dynamically accepts only CSV
        maxSizeMB: 10,
      },
      //validation:{required:true}
    },
  ];

  const DamagedInputs = () => {
    console.log('damagedformdata', formData);

    // if (orderformData?.length > 0) {
    return (
      <div className="mb-3">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
          className="col-lg-12"
        >
          <div>
            <DynamicForm
              formConfig={UploadInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
        </div>
      </div>
    );
  };

  const handleFormSubmitBulk = async (formData) => {
    // Validate form before submission
    const errors = {};
    let isValid = true;

    UploadInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await showAlert({
      title: 'Confirmation',
      text: 'Are you sure you want to add this item to stock?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      // Create FormData and append the file
      const payload = new FormData();
      payload.append('bulksrnoUpload', formData.bulksrnoUpload);

      const response = await axiosInstance.post(
        '/instock/accept-instock',
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      console.log('API Response1111:', response.data);

      if (response.status === 200) {
                handleModalClose()

        await showAlert({
          title: 'Success',
          text: 'Item added to stock successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        navigate('/admin/manage-product/stock-in');
      }
    } catch (error) {
  console.error('Error submitting form:', error);

  let errorMessage = 'An error occurred while processing your request.';

  if (error.response) {
    const { data } = error.response;

    if (Array.isArray(data?.data)) {
      // 🔹 Extract all row-level errors
      errorMessage = data.data
        .map((err) => `${err.message}`)
        .join('\n');
    } else if (data?.message) {
      errorMessage = data.message;
    }
  } else if (error.message) {
    errorMessage = error.message;
  }

  await showAlert({
    title: 'Upload Failed',
    text: errorMessage,
    icon: 'error',
    confirmButtonText: 'OK',
  });
      setLoading(false);
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Stock In</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Stock In Details
              </span>
              <DynamicForm
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  }}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div>
            </div>
            {/* Bulk Upload Section */}
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Bulk Upload Stock In
              </span>
              <DynamicForm
                formConfig={BulkUploadInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
              <div className="btncontainer mt-3">
                <button
                  className="submit-btn"
                  disabled={
                    !isFormValid(
                      BulkUploadInputs,
                      formData,
                      validationErrors,
                    ) || loading
                  }
                  style={{
                    ...buttonStyle(
                      BulkUploadInputs,
                      formData,
                      validationErrors,
                      loading,
                    ),
                    marginRight: '16px',
                  }}
                  onClick={() => {
                    handleDownload(formData);
                  }}
                >
                  Download Sample
                </button>

                {/* <button
                    onClick={() => {
                      if (!formData.itemType) {
                        setErrorMessage("Select item type first");
                        return;
                      }
                      setErrorMessage(""); 
                      handleDownload(formData);
                    }}
                    className="submit-btn"
                    style={{ marginRight: "16px" }}
                  >
                    Download Sample
                  </button>

                  {errorMessage && (
                    <p style={{ color: "red", marginTop: "8px", marginRight: "16px" }}>
                      {errorMessage}
                    </p>
                  )}
                */}

                <button onClick={handleModalOpen} className="submit-btn">
                  Upload
                </button>
              </div>
            </div>

            {showModal && (
              <div className="custom-modal-overlay">
                <div className="custom-modal-itemDetails-modal">
                  <div className="custom-modal-header">
                    <h6 style={{ fontSize: '24px', fontWeight: '600' }}>
                      Update Quantity
                    </h6>
                    <button
                      className="close-button"
                      style={{ width: '24px', height: '24px' }}
                      onClick={handleModalClose}
                    >
                      <img
                        src={cancelCsv}
                        alt="cancelCsv"
                        height={24}
                        width={24}
                      />
                    </button>
                  </div>

                  <div className="custom-modal-body-itemDetails">
                    <table
                      style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                      {/* <thead>
                        <tr
                          style={{
                            borderBottom: "1px solid lightgray",
                            paddingBottom: "10px",
                          }}
                        >
                          <th
                            style={{
                              padding: "14px",
                              textAlign: "center",
                              fontSize: "14px",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead> */}
                      <tbody>
                        <tr style={{ borderBottom: '1px solid lightgray' }}>
                          <td style={{ padding: '10px', fontSize: '14px' }}>
                            {/* Assuming DamagedInputs is a function rendering the file input */}
                            {DamagedInputs()}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="custom-modal-footer">
                    <button
                      className="submit-btn"
                      disabled={
                        !isFormValid(
                          UploadInputs,
                          formData,
                          validationErrors,
                        ) || loading
                      }
                      style={buttonStyle(
                        UploadInputs,
                        formData,
                        validationErrors,
                        loading,
                      )}
                      onClick={() => handleFormSubmitBulk(formData)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AddStockIn;
